import { UserActivityDto } from 'common/api/autogenerated/client-area';

import { sentUserLocation } from './api';
import { ActionTypes } from './useTracking.hook';

export type UserActivityType = 'onPageEnter' | 'onPageLeave';

const mapCustomerData = (action: ActionTypes): UserActivityDto => ({
  action,
  url: window.location.href,
  page: window.location.pathname,
  product: 'WebTrader',
});

export class CustomerLocationTracker {
  process(action: ActionTypes) {
    const mappedData = mapCustomerData(action);
    switch (action) {
      case 'onPageEnter':
        sentUserLocation(mappedData);
        break;
      default:
        break;
    }
  }
}
